import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'dls-z-50 dls-w-72 dls-rounded-md dls-border dls-bg-popover dls-p-4 dls-text-popover-foreground dls-shadow-20 dls-outline-none data-[state=open]:dls-animate-in data-[state=closed]:dls-animate-out data-[state=closed]:dls-fade-out-0 data-[state=open]:dls-fade-in-0 data-[state=closed]:dls-zoom-out-95 data-[state=open]:dls-zoom-in-95 data-[side=bottom]:dls-slide-in-from-top-2 data-[side=left]:dls-slide-in-from-right-2 data-[side=right]:dls-slide-in-from-left-2 data-[side=top]:dls-slide-in-from-bottom-2',
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
